<template>
    <v-navigation-drawer
        v-model="drawer"
        app
        fixed
        clipped
        :width="$vuetify.breakpoint.mobile ? '100%' : 300"
        :mini-variant.sync="mini"
        mobile-breakpoint="0"
        mini-variant-width="75"
        style="min-width: 75px;"
      >
      <v-list-item class="px-2">
        <v-btn block text @click.stop="mini = !mini" class="d-flex justify-end" >
          <v-icon v-if="mini">mdi-chevron-right</v-icon>
          <v-icon v-else>mdi-chevron-left</v-icon>
        </v-btn>
      </v-list-item>
      <v-divider v-if="!mini" />
      <v-list dense>
        <v-list-item v-for="parking in parkings" :key="parking.extension" @click="navigate()" :to="{ path: `/parking/${parking.extension}` }">
          <v-list-item-icon v-if="!mini">
            <v-icon>mdi-parking</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title><span class="font-weight-medium"></span>{{ parking.extension }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <span class="text-caption font-weight-medium">{{ parking.name }}</span>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
  </template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'parking-drawer',
  data () {
    return {
      drawer: null,
      mini: this.$vuetify.breakpoint.mobile
    }
  },
  computed: {
    ...mapGetters({
      parkings: 'parking/parkings'
    })
  },
  mounted () {
    this.setSelectedFromRoute()
  },
  watch: {
    '$route.path' () {
      this.setSelectedFromRoute()
    }
  },
  methods: {
    navigate () {
      if (this.$vuetify.breakpoint.mobile) {
        this.mini = true
      }
    },
    setSelectedFromRoute () {
      if (this.$route.path === '/parking' && this.parkings.length > 0) {
        const first = this.parkings[0]
        this.$router.replace({ path: `/parking/${first.extension}` })
        this.selectedParking = first.extension
      } else {
        const match = this.parkings.find(p => this.$route.path.includes(p.extension))
        this.selectedParking = match?.extension || null
      }
    }
  }
}
</script>

  <style>
  </style>
